import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles, createStyles, Theme, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Views } from "../../helpers/constants";
import { useDispatch } from "react-redux";
import { logout } from "../login/loginSlice";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      display: "flex",
      color: theme.palette.paused.main,
      "&:hover": {
        background: "transparent",
      },
    },
    buttonContainer: {
      marginTop: "auto",
      paddingBottom: "100px",
    },
  })
);

export default function SignOut() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  /* ---- Utils ---- */
  const handleBackToLogin = () => {
    dispatch(logout());
    history.push(Views.LOGIN);
  };

  return (
    <div className={classes.buttonContainer}>
      <Button onClick={handleBackToLogin} className={classes.button}>
        {t("sign_out")}
      </Button>
    </div>
  );
}
